import { useDashboard } from '@/hooks/useDashboard';

export function MobileTabBar() {
  const { view, setView } = useDashboard();

  return (
    <nav
      data-testid="ops-mobile-tab-bar"
      className="md:hidden fixed bottom-0 left-0 right-0 bg-slate-950 border-t border-slate-800 flex z-50"
    >
      {(['health', 'incidents'] as const).map((v) => (
        <button
          key={v}
          data-testid={`ops-mobile-nav-${v}`}
          onClick={() => setView(v)}
          className={`flex-1 py-3 text-xs font-medium text-center capitalize transition-colors ${
            view === v ? 'text-white bg-slate-800/60' : 'text-slate-400'
          }`}
        >
          {v}
        </button>
      ))}
    </nav>
  );
}
